import { saveAs } from 'file-saver';

const PLAIN_NUMBER_OR_PHONE = /^[+-]?[\d\s().-]+$/;

/**
 * Neutralizza le formule: i dati arrivano anche da clienti esterni (wizard pubblico),
 * quindi una cella come "=HYPERLINK(...)" non deve essere eseguita da Excel.
 */
function escapeCell(value: string | number | boolean | null | undefined): string {
    let text = value == null ? '' : String(value);
    if (/^[=@\t\r]/.test(text) || (/^[+-]/.test(text) && !PLAIN_NUMBER_OR_PHONE.test(text))) {
        text = "'" + text;
    }
    return /[;"\r\n]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
}

/** CSV con separatore ";" e BOM UTF-8, per l'apertura diretta in Excel italiano. */
export function downloadCsv(fileName: string,
                            headers: string[],
                            rows: Array<Array<string | number | boolean | null | undefined>>): void {
    const content = [headers, ...rows]
        .map(row => row.map(escapeCell).join(';'))
        .join('\r\n');
    saveAs(new Blob(['\ufeff' + content], {type: 'text/csv;charset=utf-8;'}), fileName);
}

export function csvFileName(prefix: string): string {
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${prefix}-${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}.csv`;
}

export function formatCsvDate(value: Date | string | null | undefined, withTime = true): string {
    if (!value) {
        return '';
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
        return '';
    }
    const pad = (n: number) => String(n).padStart(2, '0');
    const day = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
    return withTime ? `${day} ${pad(date.getHours())}:${pad(date.getMinutes())}` : day;
}
